import styled, { css } from "styled-components";
import DefaultRow from "components/Form/Row";
import { UploadPreviewFieldControl as DefaultUploadPreviewFieldControl } from "components/FormControl";
import { ImageContainer } from "components/FormControl/UploadPreviewFieldControl/styles";

export const Title = styled.text`
  font-size: 28px;
  font-weight: 500;
`;

export const GroupRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  ${({ width, marginLeft }: { width?: string, marginLeft?: string }) =>
    css`
      width: ${width ?? "100%"};
      margin-left: ${marginLeft ?? "0px"};
    `}
`;

export const Row = styled(DefaultRow)`
  gap: 20px;
  ${({
    width,
    height,
    marginTop,
  }: {
    width?: string,
    height?: string,
    marginTop?: string,
  }) =>
    css`
      width: ${width ?? "100%"};
      height: ${height ?? "100%"};
      margin-top: ${marginTop ?? "0px"};
    `}
`;
export const UploadPreviewFieldControl = styled(
  DefaultUploadPreviewFieldControl,
)`
  ${ImageContainer} {
    height: 200px;

    .filepicker {
      height: 150px;
    }

    .dropzone .dz-message {
      margin: 82px 0;
    }

    .dropzone .dz-preview .dz-image {
      width: 170px;
      height: 170px;
    }
  }
`;

export const ImagePreviewContainer = styled.div`
  min-width: 200px;
  min-height: 200px;
  width: 100%;

  background-image: url(${({ image }: { image?: string }) => image});
  background-size: contain;
  background-repeat: no-repeat;

  border-radius: 8px;
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 40px;
`;

export const ControlContainer = styled.div`
  ${({ width }: { width?: string }) =>
    css`
      width: ${width ?? "120px"};
    `}
  &:not(:last-child) {
    margin-right: 32px;
  }
`;
export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;
